import {
  CardSelectionDropdownTexts,
  CommonTexts,
  DetailsPageTexts,
  FooterComponentTexts,
  HeaderComponentTexts,
  LoginModalTexts,
  OfferListingPageTexts,
  OrderHistoryTexts,
  PreLoginPageTexts,
} from '../environment.interface';

const commonTexts: CommonTexts = {
  back: 'Back',
  orderHistory: 'Order History',
  loginButtonLabel: 'Login',
  getStarted: 'Get Started',
  orderSummary: 'Order Summary',
  copyCode: 'Copy Code',
  redeemNow: 'Redeem Now',
  validTill: 'Valid Till:',
  viewDetails: 'View Details',
  orderId: 'Order ID',
  welcome: 'Welcome',
  errorMsgs: {
    tryLater: 'Something went wrong, please try again later.',
    redirectingToOrderHistory:
      'Something went wrong, Redirecting to order history',
    paymentFailed: 'Payment Failed, try after sometime.',
  },
};

const reverificationLogoutText: string =
  'You will be logged out in {{ countdown }} seconds for reverification.';

const preLoginPage: PreLoginPageTexts = {
  header: {
    heading:
      'Discover Exclusive Offers and Premium Benefits, in Partnership with Visa',
    subHeading: 'Enjoy discounts and offers across your favourite brands',
    loginButtonLabel: 'Click here to Login',
    loginSubText: 'Already registered?',
  },
  programBenefits: {
    tabHeading: 'Program Benefits',
    heading: 'Discover limitless possibilities with your Visa card',
    offers: {
      title: 'Save with Visa',
      description:
        'Gain access to a wide variety of offers and deals, including travel, gaming, streaming, gifting and more.',
      subtext: 'Find your favorites inside.',
      linkLabel: 'Explore Offers',
    },
  },
  howToRedeem: {
    tabHeading: 'How to Redeem',
    heading: 'How to unlock your Visa Benefits?',
    steps: [
      {
        number: '1',
        title: 'Sign up',
        description:
          'If you are new to this program please enter your card details to register',
      },
      {
        number: '2',
        title: 'Verify your Email',
        description: 'Enter your registered email id and verify using OTP.',
      },
      {
        number: '3',
        title: '3DS Verification',
        description:
          'Enter your card details to authenticate to unlock rewards',
      },
    ],
  },
};

const offerListingPage: OfferListingPageTexts = {
  heading: 'Enjoy fantastic discounts with your Visa card',
  categoryLabel: 'Categories',
  allCategoryLabel: 'All',
  offersTabLabel: 'Enjoy Discounts',
  dealsTabLabel: 'Exclusive Deals',
  offerCardsConfig: {
    primaryBtnLabel: 'Claim Offer',
  },
};

const orderHistoryPage: OrderHistoryTexts = {
  categories: [
    { name: 'Discount Offers', type: 'offer' },
    { name: 'Exclusive Deals', type: 'exclusive' },
  ],
  noVoucherText: 'No Voucher Required',
  redeemFailedMessages: {
    title: 'Some error occurred.',
    subtitle: 'Please try again later.',
  },
  validityText: 'Validity:',
  redirectionTexts: {
    hyperlinkText: 'Click here',
    normalText: 'to learn how to redeem the offer code.',
  },
  generatedOnText: 'Generated on:',
  voucherCodeText: 'Voucher Code',
  statusMessages: {
    failed: 'Failed',
    successful: 'Successful',
    cancelled: 'Cancelled',
    confirmed: 'Confirmed',
  },
  merchantOfferText: 'Merchant Offer',
  cardUsedText: 'Card Used:',
  couponHelperText:
    'Please use your coupon code at checkout in merchant app/site',
  noOffersText: 'No offers found',
  cancelNow: 'Cancel Now',
  cabService: 'Cab Service',
  from: 'from',
  to: 'to',
  car: 'Car',
  errorMsgs: { bookingCancelled: 'Booking cancelled successfully' },
};

const footerComponent: FooterComponentTexts = {
  faqLabel: 'FAQ',
  poweredBy: 'Powered By',
  privacyPolicyLabel: 'Privacy Policy',
  termsAndConditionsLabel: 'Terms and Conditions',
};

const headerComponent: HeaderComponentTexts = {
  logoutButtonLabel: 'Logout',
  searchBarPlaceholder: 'Search for brands or merchants',
  search: 'Search',
};

const loginModal: LoginModalTexts = {
  faqLine: {
    before: 'Please refer to our',
    link: 'FAQs',
    after: 'for more details',
  },
  landingSectionTitle: 'Provide your Card details and check your eligibility',
  heading: 'Unlock your benefits',
  cardVerification: 'Card verification',
  registerButtonLabel: 'Unlock my Offers',
  returningUserLabel: 'Returning user?',
  cardNumberLabel: 'Enter Your Visa Card Number',
  emailIdLabel: 'Enter your login Email Id',
  emailIdErrorMsg: 'Please enter valid email id',
  consent1: {
    text: 'By signing in, you agree to our',
  },
  consent2: {
    body: `By checking this box, you agree that Visa may collect, use, process and share your personal information for the purposes of administering and managing the Campaign in accordance with Visa's`,
    link: 'Global Privacy Notice',
  },
  pcidssText:
    'Card and account numbers are only used to check your eligibility and are encrypted.',
  tryAgain: 'Try Again',
  authPassMsg: 'Authentication Successful!',
  authFailMsg: 'Authentication Failed!',
  waitingForBank: 'Waiting for your bank...',
  unlockingVouchers: 'Unlocking your vouchers...',
  takeFewMinutes: 'This may take a few minutes',
  visaCard: 'Visa Card',
  expiryDate: 'Expiry Date (MM/YY)',
  redirectionText: {
    title: `You'll be redirected to the issuer's website*`,
    subtitle:
      '*Visa shall not be responsible for any error in communication between you and the issuer',
  },
  otpMessages: {
    resend: 'Resend OTP',
    sent: 'OTP resent successfully.',
    resendIn: 'Resend OTP in',
    enter: 'Enter OTP sent to',
    request: 'Request OTP',
    invalid: 'Invalid OTP.',
    maxInvalid: 'Maximum invalid otp attempts reached.',
    attemptsLeft: '{{attempts}} more attempt(s) left.',
    tooltip:
      'Kindly check your spam folder if you have not received the OTP in your inbox',
  },
  change: 'Change',
  submitBtnTitles: {
    proceed: 'Proceed',
    submit: 'Submit',
    authCard: 'Authenticate Card',
    requesting: 'Requesting',
  },
  placeholders: { month: 'MM', year: 'YY' },
  errorMsgs: {
    invalidCard: 'Invalid Card Number',
    cardAlreadyMappedWithEmail:
      'Card is already mapped with another email. Please use your registered email to login',
    cardNotEligible:
      'Card number entered is not eligible. Please try again with an eligible Card',
    invalidUserCredentials: 'Please enter a valid/registered email id or card',
    verificationFailed: 'Verification failed. Please try again after some time',
    defaultErrorMsg1: 'Please enter a valid/registered email id to login',
    defaultErrorMsg2:
      'Email id entered is not registered. Kindly enter you registered email id to login or register using your card & email id.',
    tryAgain: 'Please try again in {{time}} minute(s).',
    expiry: {
      month: {
        invalid: 'Expiry month is invalid',
        required: 'Expiry month is required',
      },
      year: {
        required: 'Expiry year is required',
        invalid: 'Expiry year is invalid',
      },
    },
  },
};

const cardSelectionDropdown: CardSelectionDropdownTexts = {
  addNewCard: 'Add new card',
  reVerify: 'Re-verify',
  unverified: 'Unverified',
};

const detailsPage: DetailsPageTexts = {
  about: 'About',
  orderDetails: 'Order Details',
  amount: 'Amount',
  discount: 'Discount',
  totalPrice: 'Total Price',
  payNow: 'Pay Now',
  redeemed: 'Redeemed',
  buyNow: 'Buy Now',
  redeemNow: 'Redeem Now',
  readMore: 'Read More',
  readLess: 'Read Less',
  errorMsgs: {
    failedBooking: 'Failed to create booking',
  },
};

export const languageSpecificConfigs = {
  reverificationLogoutText,
  preLoginPage,
  offerListingPage,
  orderHistoryPage,
  footerComponent,
  headerComponent,
  commonTexts,
  loginModal,
  cardSelectionDropdown,
  detailsPage,
};
